import { initSwiper } from '@resources/js/components/initSwiper';
import inViewport from '@resources/js/helpers/inViewport';
const sectionElement = document.querySelector('.js-tip-cards');
inViewport(sectionElement, () => {
    const sliderElement = sectionElement.querySelector('.js-slider-container');
    initSwiper(sliderElement, {
        slidesPerView: 1.2,
        loop: false,
        spaceBetween: 16,
        breakpoints: {
            550: {
                slidesPerView: 1.8,
            },
            768: {
                slidesPerView: 2.1,
            },
            900: {
                slidesPerView: 3,
                spaceBetween: 32,
                touchStartPreventDefault: false,
            },
        },
    });
});
